import ChevronLeftRounded from '@mui/icons-material/ChevronLeftRounded';
import IconButton from '@mui/material/IconButton';

const NavigationBackButton = ({ onBackClick }) => {
  return (
    <IconButton onClick={onBackClick} aria-label="back" size="small" sx={{ mr: '5px', borderRadius: '8px' }}>
      <ChevronLeftRounded sx={{ verticalAlign: 'middle', width: 20, height: 20 }} />
    </IconButton>
  );
};

export default NavigationBackButton;
